import React from "react";
import { Box, Container, Stack, Typography, Link, IconButton } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { company } from "../../data/siteContent";
import { colors } from "../../theme";

export default function TopBar() {
  return (
    <Box
      component="div"
      sx={{
        bgcolor: colors.navy,
        color: "#fff",
        py: 0.75,
        display: { xs: "none", md: "block" },
        fontSize: "0.875rem",
      }}
    >
      <Container maxWidth="lg">
        <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Global digital engineering from Indore, India
          </Typography>
          <Stack direction="row" spacing={2.5} alignItems="center" flexWrap="wrap">
            <Stack direction="row" spacing={0.5} alignItems="center">
              <PhoneOutlinedIcon sx={{ fontSize: 16, opacity: 0.85 }} />
              <Link href={`tel:${company.phoneTel}`} color="inherit" underline="hover">
                {company.phone}
              </Link>
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <EmailOutlinedIcon sx={{ fontSize: 16, opacity: 0.85 }} />
              <Link href={`mailto:${company.email}`} color="inherit" underline="hover">
                {company.email}
              </Link>
            </Stack>
            <Stack direction="row" spacing={0.5}>
              <IconButton
                size="small"
                href={company.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#fff" }}
                aria-label="LinkedIn"
              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                href={company.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: "#fff" }}
                aria-label="Facebook"
              >
                <FacebookIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
